import $ from 'jquery';
import bindEvent from '../../scripts/util/bindEvent';
import isElement from '../../scripts/util/isElement';
import 'malihu-custom-scrollbar-plugin';

const selectors = {
	tabs: '.js-sample-tabs',
	tab: '.js-sample-tab',
	container: '.js-sample-container',
	control: '.js-sample-control'
};

const classes = {
	active: {
		control: 'sample-tabs__control_state_active',
		tab: 'sample-tabs__tab_state_active'
	}
};

const scrollbarSettings = {
	theme: 'custom'
};

const $scroller = $(selectors.container);

const toggleTab = e => {
	const target = e.currentTarget;
	const tabs = document.querySelector(selectors.tabs);
	const container = tabs.querySelector(selectors.container);
	const id = target.dataset.id;
	const activeControl = tabs.querySelector(`.${classes.active.control}`);
	const activeTab = tabs.querySelector(`.${classes.active.tab}`);
	const targetTab = container.querySelector(`[data-id='${id}']`);

	activeControl.classList.remove(classes.active.control);
	target.classList.add(classes.active.control);
	activeTab.classList.remove(classes.active.tab);
	targetTab.classList.add(classes.active.tab);
};

const render = () => {
	if (isElement(selectors.tabs)) {
		bindEvent(selectors.control, 'click', toggleTab);
		$scroller.mCustomScrollbar(scrollbarSettings);
	}
};

export default render;
